import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { store } from 'redux-rest-reducer';
import debounce from 'lodash.debounce';

import styled from 'styled-components';
import COLORS from 'constants/colors';

import { Text, Button, Separator, FlexView } from '@cuemath/comps';
import { SelectInput, getOptions } from 'modules/form';
import { getAll as getTeacherList } from 'actions/teacher-list';
import { get as getTeacherDetails } from 'actions/teachers';

import { TEACHERS_PER_PAGE } from 'constants/list';
import { OPTIONS } from 'constants/form';

const Wrapper = styled(FlexView)`
  margin: 15px;
`;
const HeadingText = styled(Text)`
  padding: 10px;
  margin: 5px;
`;
const StyledSelectInput = styled(SelectInput)`
  margin: 10px;
`;
const StyledButton = styled(Button)`
  margin: 10px auto;
`;
const TextWrapper = styled(Text)`
  margin: 30px 0;
`;

class AssignTeacher extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      getTeacherList: PropTypes.func.isRequired,
    }).isRequired,
    patchFoundationStudent: PropTypes.func.isRequired,
    errorText: PropTypes.string,
    demoTeacherId: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      teacherId: null,
      teachersData: [],
      defaultTeacherOption: null,
      teacherSearchKey: null,
      warningText: null,
    };
  }

  static getDerivedStateFromProps(props, state) {
    const { teacherList, demoTeacherId, teachers } = props;
    const { defaultTeacherOption, teacherSearchKey } = state;
    const listParams = { page: 1, per_page: TEACHERS_PER_PAGE, search: teacherSearchKey };
    const newState = {};
    const teachersDataGet = store.getAll(teacherList, listParams);

    if (teachersDataGet && teachersDataGet.isLoaded) {
      newState.teachersData = teachersDataGet.data;
    }

    if (demoTeacherId && !defaultTeacherOption) {
      const teacherDetailsGet = store.get(teachers, demoTeacherId);

      if (teacherDetailsGet && teacherDetailsGet.isLoaded && teacherDetailsGet.data) {
        const { name, phone } = teacherDetailsGet.data;
        if (name && phone) {
          newState.defaultTeacherOption = {
            label: `${name}-${phone}`,
            value: demoTeacherId,
          };
          newState.teacherId = demoTeacherId;
        }
      }
    }
    return newState;
  }

  componentDidMount() {
    const { actions, demoTeacherId } = this.props;

    if (demoTeacherId) {
      actions.getTeacherDetails(demoTeacherId);
    }
  }

  onTextChange = (val, reason) => {
    const { action } = reason;
    const { actions } = this.props;
    const { warningText } = this.state;
    const listParams = { page: 1, per_page: TEACHERS_PER_PAGE, search: val };
    const filterData = {
      page: 1,
      per_page: TEACHERS_PER_PAGE,
      state: ['ACT', 'INTR', 'FDTR'],
      search: val,
    };

    if (val.length <= 4 && action !== 'menu-close') {
      this.setState({ warningText: 'Please enter more than 4 characters' });
      return;
    }
    if (warningText) {
      this.setState({ warningText: null });
    }

    if (action !== 'menu-close' || val.length !== 0) {
      this.setState({ teacherSearchKey: val }, () => {
        actions.getTeacherList(listParams, filterData);
      });
    }
  };

  renderFormFields = () => {
    const { teachersData = [], defaultTeacherOption } = this.state;

    const teacherOptions = getOptions({
      field: OPTIONS.TEACHERS_LIST,
      teachersDataOptions: teachersData,
    });

    return (
      <>
        <Text size="medium" weight="semibold">
          Assign Teacher
        </Text>

        <StyledSelectInput
          name="teacher"
          options={teacherOptions}
          onInputChange={debounce((val, reason) => this.onTextChange(val, reason), 1000)}
          onChange={this.onTeacherSelect}
          isMulti={false}
          value={defaultTeacherOption}
        />
      </>
    );
  };

  onTeacherSelect = teacher => {
    this.setState({
      teacherId: teacher.value,
      defaultTeacherOption: teacher,
    });
  };

  render() {
    const { teacherId, warningText } = this.state;
    const { patchFoundationStudent, errorText } = this.props;

    return (
      <Wrapper>
        <HeadingText size="large" align="center" weight="bold">
          Create Foundation Profile
        </HeadingText>
        <Text size="small">
          Please select an appropriate teacher,with which the student & the payments will
          be mapped in foundation
        </Text>
        {this.renderFormFields()}
        <StyledButton
          label="Create Foundation Student"
          onClick={() => patchFoundationStudent(teacherId)}
          disabled={!teacherId}
        />
        {errorText && (
          <Text color={COLORS.RED} size="small" align="center">
            {errorText}
          </Text>
        )}
        {warningText && (
          <Text color={COLORS.RED} size="small" align="center">
            {warningText}
          </Text>
        )}
        <TextWrapper>
          <Text size="medium" weight="bold">
            IMPORTANT DIRECTIVES.
          </Text>
          <Separator height={15} transparent></Separator>
          <Text size="small" weight="bold">
            IF CHAGNING THE TEACHER IS REQUIRED
          </Text>
          <Separator height={10} transparent></Separator>
          <Text size="small">
            1. Select the APPROPRIATE TEACHER TO BE MAPPED with student
          </Text>
          <Text size="small">
            2. YOU WILL BE REDIRECTED to the FOUNDATION PAYMENT LINK generation page.
          </Text>
          <Text size="small">3. Select APPROPRIATE MONTHS & generate the LINK.</Text>
        </TextWrapper>
      </Wrapper>
    );
  }
}

export default connect(
  ({ foundationPayment, teacherList, teachers }) => ({
    foundationPayment,
    teacherList,
    teachers,
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        getTeacherList,
        getTeacherDetails,
      },
      dispatch,
    ),
  }),
)(AssignTeacher);
